import type { AbsenceRequest } from "@/lib/absence-tracking-api"

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

import { AbsenceTable } from "./absence-table"

export function AbsenceHistoryCard({
  historyItems,
}: {
  historyItems: AbsenceRequest[]
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Past activity</CardTitle>
        <CardDescription>
          Your previous absences, cancellations, and completed time away.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <AbsenceTable items={historyItems} emptyLabel="No past absences yet." />
      </CardContent>
    </Card>
  )
}
